<template>
    <div>
        <div class="row">
            <div class="col-lg-3">
                {{ $t('Partner') }}
            </div>
            <div class="col-lg-9">
                <select class="form-control" v-model="partner" @input="onChange">
                    <option v-for="partner in partners" :value="partner">{{ partner.title }}</option>
                </select>
            </div>
        </div>
        <div class="row mt-1">
            <div class="col-lg-3">
                {{ $t('Event') }}
            </div>
            <div class="col-lg-9">
                <resource-input
                    :filters="eventFilters"
                    :url="eventsUrl"
                    v-model="event"
                    @input="onChange">
                </resource-input>
            </div>
        </div>

        <hr>

        <div v-if="result">
            <div class="card">
                <div class="card-block">
                    {{ result.name }}
                    <hr>
                    <div class="row">
                        <div class="col">
                            <div>{{ result.min_date_start }}</div>
                            <div>{{ result.min_date_end }}</div>
                            <div v-if="result.prices.hotel_package">
                                <div>{{ result.prices.hotel_package.room_type_name }}</div>
                                <div>&euro; {{ result.prices.hotel_package.price }}</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <img src="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import VueMultiselect from 'vue-multiselect/src/Multiselect'
    import ResourceInput from '../ResourceInput'

    export default {
        components: { ResourceInput, VueMultiselect },
        props: {
            partners: {
                type: Array,
                required: true
            },
            eventsUrl: {
                type: String,
                required: true
            },
            apiEndpoint: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                partner: this.partners[0],
                event: null,
                result: null,
                eventFilters: {
                    date_time_gt: new Date().toISOString().split('T')[0]
                },
                axios: axios.create({ baseURL: this.apiEndpoint })
            }
        },
        methods: {
            onChange() {
                if (!this.partner || !this.event) {
                    return null
                }

                this.queryApi(this.partner, this.event)
            },
            queryApi(partner, event) {
                this.axios
                    .request({
                        url: '/events/' + event.uuid,
                        headers: { 'Authorization': 'Bearer ' + partner.api_key }
                    })
                    .then((response) => {
                        this.result = response.data.data
                    }).catch((data) => {
                        console.log(data)
                    })
            }
        }
    }
</script>
